/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './mwl-item.reducer';

export const MWLItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mWLItemEntity = useAppSelector(state => state.mWLItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mWLItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.mWLItem.detail.title">MWLItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.mWLItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.id}</dd>
          <dt>
            <span id="accessionNo">
              <Translate contentKey="tinyMedicRestApp.mWLItem.accessionNo">Accession No</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.accessionNo}</dd>
          <dt>
            <span id="createdTime">
              <Translate contentKey="tinyMedicRestApp.mWLItem.createdTime">Created Time</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.createdTime}</dd>
          <dt>
            <span id="institution">
              <Translate contentKey="tinyMedicRestApp.mWLItem.institution">Institution</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.institution}</dd>
          <dt>
            <span id="department">
              <Translate contentKey="tinyMedicRestApp.mWLItem.department">Department</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.department}</dd>
          <dt>
            <span id="localAet">
              <Translate contentKey="tinyMedicRestApp.mWLItem.localAet">Local Aet</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.localAet}</dd>
          <dt>
            <span id="modality">
              <Translate contentKey="tinyMedicRestApp.mWLItem.modality">Modality</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.modality}</dd>
          <dt>
            <span id="reqProcId">
              <Translate contentKey="tinyMedicRestApp.mWLItem.reqProcId">Req Proc Id</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.reqProcId}</dd>
          <dt>
            <span id="spsId">
              <Translate contentKey="tinyMedicRestApp.mWLItem.spsId">Sps Id</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.spsId}</dd>
          <dt>
            <span id="spsStartDate">
              <Translate contentKey="tinyMedicRestApp.mWLItem.spsStartDate">Sps Start Date</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.spsStartDate}</dd>
          <dt>
            <span id="spsStartTime">
              <Translate contentKey="tinyMedicRestApp.mWLItem.spsStartTime">Sps Start Time</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.spsStartTime}</dd>
          <dt>
            <span id="spsStatus">
              <Translate contentKey="tinyMedicRestApp.mWLItem.spsStatus">Sps Status</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.spsStatus}</dd>
          <dt>
            <span id="studyIuid">
              <Translate contentKey="tinyMedicRestApp.mWLItem.studyIuid">Study Iuid</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.studyIuid}</dd>
          <dt>
            <span id="updatedTime">
              <Translate contentKey="tinyMedicRestApp.mWLItem.updatedTime">Updated Time</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.updatedTime}</dd>
          <dt>
            <span id="dicomAttrs">
              <Translate contentKey="tinyMedicRestApp.mWLItem.dicomAttrs">Dicom Attrs</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.dicomAttrs}</dd>
          <dt>
            <span id="instCode">
              <Translate contentKey="tinyMedicRestApp.mWLItem.instCode">Inst Code</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.instCode}</dd>
          <dt>
            <span id="deptCode">
              <Translate contentKey="tinyMedicRestApp.mWLItem.deptCode">Dept Code</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.deptCode}</dd>
          <dt>
            <span id="procedurePriority">
              <Translate contentKey="tinyMedicRestApp.mWLItem.procedurePriority">Procedure Priority</Translate>
            </span>
          </dt>
          <dd>{mWLItemEntity.procedurePriority}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mWLItem.admission">Admission</Translate>
          </dt>
          <dd>{mWLItemEntity.admission ? mWLItemEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mWLItem.admidIssuer">Admid Issuer</Translate>
          </dt>
          <dd>{mWLItemEntity.admidIssuer ? mWLItemEntity.admidIssuer.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mWLItem.patient">Patient</Translate>
          </dt>
          <dd>{mWLItemEntity.patient ? mWLItemEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mWLItem.accnoIssuer">Accno Issuer</Translate>
          </dt>
          <dd>{mWLItemEntity.accnoIssuer ? mWLItemEntity.accnoIssuer.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mWLItem.perfPhysName">Perf Phys Name</Translate>
          </dt>
          <dd>{mWLItemEntity.perfPhysName ? mWLItemEntity.perfPhysName.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mWLItem.refPhysName">Ref Phys Name</Translate>
          </dt>
          <dd>{mWLItemEntity.refPhysName ? mWLItemEntity.refPhysName.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mWLItem.reqPhysName">Req Phys Name</Translate>
          </dt>
          <dd>{mWLItemEntity.reqPhysName ? mWLItemEntity.reqPhysName.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/mwl-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/mwl-item/${mWLItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MWLItemDetail;
